export default __webpack_public_path__ + "static/signifier-light-0d2e4644e658b93bbe8f3386f48276d0.woff2";